import React from 'react';

class Row extends React.Component {
    constructor(props) {
        super(props);
        this.state = { }
    }

    createComponentClasses() {
        let {
            className
        } = this.props;

        let classNames = ['row'];
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render() {
        let { children } = this.props;
        return (
            <div className={ this.createComponentClasses() }>
                { children }
            </div>
        )
    }
}

export default Row;